(function(){
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
if(reduce) document.documentElement.classList.add('still');
const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
const $=id=>document.getElementById(id);
/* closed-book choreography: [p, rotY, rotX] — the spin at the end turns it once more and settles at an angle */
const K=[[0,-28,8],[.04,-18,6],[.1,72,4],[.16,180,3],[.22,360,0],[.86,360,0],[.97,700,8],[1,700,8]];
function pose(p){
for(let i=0;i<K.length-1;i++){const a=K[i],b=K[i+1];
if(p<=b[0]){const t=ease(clamp((p-a[0])/(b[0]-a[0]),0,1));return [a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t];}}
return [700,8];
}
const win=(p,a,b)=>ease(clamp((p-a)/(b-a),0,1));
const N=3, OPEN=[[.22,.29],[.31,.36],[.37,.43]], SHUT=[[.81,.86],[.775,.81],[.73,.775]];
const ZIN=[.45,.53], ZOUT=[.66,.72];
const panelsAt=[[0,.035],[.045,.1],[.11,.165],[.23,.37],[.41,.74],[.87,1.01]];
const book=$('book'), leaves=[];
for(let k=0;k<N;k++){
const el=document.createElement('div'); el.className='leaf'+(k?'':' cv');
el.innerHTML='<div class="face lf"></div><div class="face lb"></div>';
if(k){el.children[0].style.backgroundImage=`url(https://cdn.shopify.com/s/files/1/0722/6972/5887/files/salah-p${2*k-1}.jpg)`;el.children[1].style.backgroundImage=`url(https://cdn.shopify.com/s/files/1/0722/6972/5887/files/salah-p${2*k}.jpg)`;}
book.appendChild(el); leaves.push(el);
}
const base=book.querySelector('.base'), anchorEl=book.parentElement;
const stage=$('stage'), glow=$('glow'), floor=$('floor'), cue=$('cue'), folio=$('folio');
const panels=[...document.querySelectorAll('#copy .panel')];
$('dots').innerHTML=panels.map(()=>'<span></span>').join(''); const dots=[...$('dots').children];
const journey=$('journey'), track=$('track'), steps=[...track.children];
let target=0, cur=0, jt=0, jc=0;
const phone=()=>innerWidth<=820;
let ZMAX=1;
function fit(){
book.style.removeProperty('--W');
const w=book.offsetWidth, h=book.offsetHeight;
ZMAX=phone()?Math.min(.94*innerWidth/w,.8*innerHeight/h):Math.min(.86*innerHeight/h,1.9);
ZMAX=Math.max(1,ZMAX);
book.style.setProperty('--W',(w*ZMAX)+'px');
}
function readScroll(){
const r=stage.getBoundingClientRect(); target=clamp(-r.top/(stage.offsetHeight-innerHeight),0,1);
const jr=journey.getBoundingClientRect(); jt=clamp(-jr.top/(journey.offsetHeight-innerHeight),0,1);
}
function renderBook(p,time){
const [ry,rx0]=pose(p), W=book.offsetWidth, T=W*.1746, d=.35;
const f=leaves.map((_,k)=>win(p,...OPEN[k])-win(p,...SHUT[k]));
const o=f[0], zm=win(p,...ZIN)-win(p,...ZOUT);
const ar=anchorEl.getBoundingClientRect();
let cx, cy;
if(phone()){cx=innerWidth/2;cy=innerHeight*.5;} else {cx=ar.left;cy=innerHeight*.5;}
const sc=(1+(ZMAX-1)*zm)/ZMAX;
const dx=(cx-ar.left)*zm, dy=(cy-ar.top)*zm;
const off=W*sc*(.5*o+.5*zm);
const rx=(rx0+8*o)*(1-zm);
const bob=Math.sin(time/1400)*6*(1-o*.7)*(1-zm), sway=Math.sin(time/2300)*2.5*(p<.03?1:0);
book.style.transform=`translate3d(${dx+off}px,${dy+bob}px,0) scale3d(${sc},${sc},${sc}) rotateX(${rx}deg) rotateY(${ry+sway}deg)`;
leaves.forEach((el,k)=>{
el.style.transform=`translateZ(${T/2}px) rotateY(${-180*f[k]}deg) translateZ(${-k*d}px)`;
el.style.setProperty('--s',(Math.sin(Math.PI*f[k])*.22).toFixed(3));
});
base.style.transform=`translateZ(${T/2-N*d}px)`;
const a=((ry%360)+360)%360; book.style.setProperty('--sheen',Math.max(0,1-Math.abs(a-20)/40));
glow.style.setProperty('--dawn',clamp(p*1.2,0,1));
floor.style.opacity=(1-Math.abs(Math.sin(ry*Math.PI/180))*.35)*(1-zm);
floor.style.transform=`translateX(-50%) scaleX(${1+o})`;
folio.style.opacity=0;
panels.forEach((el,i)=>{let [a0,b0]=panelsAt[i];const fd=.012;
let v=i===0?clamp((b0-p)/fd,0,1):Math.min(clamp((p-a0)/fd,0,1),clamp((b0-p)/fd,0,1));
if(i===4&&phone()) v*=1-zm;   // on a phone the zoomed page takes the screen
el.style.opacity=v; el.style.pointerEvents=v>.5?'auto':'none'; el.style.translate=`0 ${(1-v)*18}px`;
dots[i].classList.toggle('on',v>.5);});
cue.style.opacity=clamp(1-p*30,0,1);
}
function renderJourney(p){
const max=track.scrollWidth-innerWidth;
track.style.transform=`translate3d(${-max*p}px,0,0)`;
journey.style.setProperty('--jp',p);
const idx=Math.round(p*(steps.length-1));
steps.forEach((s,i)=>s.classList.toggle('lit',i===idx));
}
const cv=$('sky'), cx=cv.getContext('2d'); let motes=[], dpr=1;
function size(){dpr=Math.min(2,devicePixelRatio||1);cv.width=cv.clientWidth*dpr;cv.height=cv.clientHeight*dpr;
const n=Math.round(clamp(cv.clientWidth/18,30,90));
motes=Array.from({length:n},()=>({x:Math.random(),y:Math.random(),r:.4+Math.random()*1.6,s:.00003+Math.random()*.00009,a:.15+Math.random()*.5,w:Math.random()*6.28}));}
function drawSky(time){const w=cv.width,h=cv.height;cx.clearRect(0,0,w,h);
for(const m of motes){m.y-=m.s*16;m.x+=Math.sin(time/3000+m.w)*.00008;if(m.y<-.02){m.y=1.02;m.x=Math.random();}
const tw=.6+.4*Math.sin(time/900+m.w*3);cx.beginPath();cx.fillStyle=`rgba(225,205,150,${m.a*tw*.55})`;cx.arc(m.x*w,m.y*h,m.r*dpr,0,6.283);cx.fill();}}
function loop(time){cur+=(target-cur)*.09; jc+=(jt-jc)*.12; renderBook(cur,time); renderJourney(jc); drawSky(time); requestAnimationFrame(loop);}
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('pre');io.unobserve(e.target);}}),{threshold:.2});
if(!reduce) document.querySelectorAll('.reveal').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('pre');io.observe(el);}});
addEventListener('scroll',readScroll,{passive:true});
addEventListener('resize',()=>{size();fit();readScroll();});
size(); fit(); readScroll();
if(!reduce) requestAnimationFrame(loop);
})();
(function(){
const shelf=document.getElementById('shelf'); if(!shelf) return;
const books=[...shelf.children], plank=document.getElementById('plank'), hint=document.getElementById('hint');
const title=document.getElementById('bk-title'), desc=document.getElementById('bk-desc');
const chips=[0,1,2].map(i=>document.getElementById('chip-'+i));
const still=matchMedia('(prefers-reduced-motion: reduce)').matches;
const INFO=[
["Sacred Echoes of the Qur'an","A quiet conversation across the 30 juz' of the Qur'an, one reflection for each. It began as personal notes from his tadabbur sessions and has reached more than 100,000 readers."],
["Ṣalāh — A Reflection","Every pillar of the prayer, read through its language and through reflection. The newest of the three."],
["Al-Kalimat: The Gift of Qur'anic Words","Language as a bridge to knowing Allah. Each chapter stays with a word of the Qur'an until its layered meanings begin to unfold."]
];
const DEFAULT=[title.textContent,desc.textContent];
const st=books.map(()=>({pull:0,turn:0,open:0,spin:0,hov:0}));
const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
const tweens=[];
function tween(o,k,to,ms){return new Promise(res=>{
if(still){o[k]=to;return res();}
const from=o[k],t0=performance.now(); tweens.push({o,k,from,to,t0,ms,res});});}
let active=-1, busy=false;
async function openBook(i){
const s=st[i]; chips[i].setAttribute('aria-pressed','true');
title.textContent=INFO[i][0]; desc.textContent=INFO[i][1];
await tween(s,'pull',1,550); await tween(s,'turn',1,650); await tween(s,'open',1,750);
}
async function closeBook(i){
const s=st[i]; chips[i].setAttribute('aria-pressed','false');
await tween(s,'open',0,550);
await Promise.all([tween(s,'turn',0,1000),tween(s,'spin',1,1000)]); s.spin=0;
await tween(s,'pull',0,500);
}
async function pick(i){
if(busy) return; busy=true;
if(active===i){await closeBook(i); active=-1; title.textContent=DEFAULT[0]; desc.textContent=DEFAULT[1];}
else{ if(active>=0) await closeBook(active); active=i; await openBook(i);}
busy=false;
}
books.forEach((b,i)=>{
b.addEventListener('click',()=>pick(i));
b.addEventListener('pointerenter',()=>{st[i].hovT=1}); b.addEventListener('pointerleave',()=>{st[i].hovT=0});
});
chips.forEach((c,i)=>c.addEventListener('click',()=>pick(i)));
function frame(now){
for(let j=tweens.length-1;j>=0;j--){const w=tweens[j],t=Math.min(1,(now-w.t0)/w.ms);
w.o[w.k]=w.from+(w.to-w.from)*ease(t); if(t>=1){tweens.splice(j,1);w.res();}}
const W=books[0].offsetWidth, H=W*1.461, Z=innerWidth<=820?1.05:1.2;
plank.style.setProperty('--plank',(H/2)+'px');
let anyOut=0;
books.forEach((b,i)=>{const s=st[i]; anyOut=Math.max(anyOut,s.pull);
s.hov+=((s.hovT||0)-s.hov)*.15;
const T=W*(b.classList.contains('salah')?.1746:.154);
const slot=(i-1)*(T+4);
const x=slot*(1-s.pull) + s.open*W*.5*Z;
const y=-s.hov*10*(1-s.pull) - s.pull*20;
const z=s.hov*14*(1-s.pull) + s.pull*170;
const sc=1+(Z-1)*s.pull;
const ry=78*(1-s.turn) - 360*s.spin;
const rx=s.pull*5;
const bob=still?0:Math.sin(now/1500)*4*s.pull*(1-s.open);
b.style.transform=`translate3d(${x}px,${y+bob}px,${z}px) scale3d(${sc},${sc},${sc}) rotateX(${rx}deg) rotateY(${ry}deg)`;
b.querySelector('.cvr').style.transform=`translateZ(${T/2}px) rotateY(${-172*s.open}deg)`;
b.style.zIndex=s.pull>0?2:1;
});
plank.style.opacity=1-anyOut*.6; hint.style.opacity=1-anyOut;
requestAnimationFrame(frame);
}
requestAnimationFrame(frame);
})();
